import React from "react";

const Selfie = () => {

    // check-availability-modal

    return (
        <div className="modal custom-modal fade " id="selfie" role="dialog"  >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content py-0" >


                    <div className="modal-body">

                        <div className="row mb-2 align-items-center justify-content-center text-center">

                            <div className="col-2 col-md-4 ">

                            </div>
                            <div className="col-8 col-md-4 text-center">
                                <h4 className=" "> License with Selfie  </h4>
                            </div>
                            <div className="col-2 col-md-4   ">
                                <span className="align-center justify-content-end text-black fs-xx-large"
                                    //  data-bs-toggle="modal"
                                    //  data-bs-target="#selfie"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                        // closeConfirmModal()
                                    }} >
                                    ×
                                </span>
                            </div>
                        </div>

                        <div >
                            <p> <b> Use Your Smartphone: </b> </p>

                            <p> Open your camera app on your smartphone and switch to the front-facing camera to prepare for the selfie.</p>

                            <p> <b> Position Your License:</b></p>

                            <p>   Hold your license at an angle that clearly displays all important information while ensuring it doesn&apos;t obscure your face. Adjust the distance so that both your face and the license are in focus. </p>

                            <p>   <b> Center Your Face:</b>  </p>

                            <p>   Frame your face in the center of the shot. Position your license close to your face, ensuring it&apos;s visible but not obstructing your facial features.  </p>

                            <p>  <b> Capture Multiple Shots:</b>  </p>

                            <p>   Take several photos in quick succession to give yourself a variety of angles and expressions to choose from. Experiment with slight adjustments in positioning for better results.  </p>

                            <p>   <b> Review and Select:</b>  </p>

                            <p>   After capturing your selfie, go through the images and select the one that best represents your desired look. Consider clarity, expression, and the visibility of your license when making your choice.  </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Selfie;